// extracted by mini-css-extract-plugin
export default {"mainDiv":"InstaGramParticipatePopup_mainDiv__sUKp1","container":"InstaGramParticipatePopup_container__8wpvr","button":"InstaGramParticipatePopup_button__TOhVH"};